import type { PolicyType } from '@/api/schemas/policy';

export function formatPolicyTitle(type: PolicyType): string {
  switch (type) {
    case 'TERMS_OF_SERVICE':
      return 'Terms of Service';
    case 'PRIVACY_POLICY':
      return 'Privacy Policy';
    case 'EULA':
      return 'End User License Agreement';
    default:
      return type;
  }
}
